import React, { FC, ReactNode, useState, useEffect } from "react";
import { Link } from "gatsby";
import * as styles from "./header.module.scss";
import { useTranslation } from "react-i18next";
import { scrollToElement } from "../../../shared/utils/utils";

interface HeaderProps {
  isHomePage?: boolean;
  contentImage?: string;
  contentDirection?: "defaul" | "reverse";
  children?: ReactNode;
  showDefaultBg?: boolean;
  showScrollButton?: boolean;
  bgImage?: string;
}

export const Header: FC<HeaderProps> = ({
  isHomePage = true,
  contentImage,
  contentDirection,
  children,
  showDefaultBg,
  showScrollButton,
  bgImage,
}) => {
  const { t } = useTranslation();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const headerStyle =
    isClient && bgImage
      ? {
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }
      : undefined;

  return (
    <header
      className={`${styles.header} ${
        isHomePage ? styles.header__homePage : ""
      } ${!!children ? styles.withChildren : ""} ${
        showDefaultBg ? styles.defaultBg : ""
      }`}
      style={headerStyle}
    >
      {/* TODO: think about it */}
      {/* <div className={styles.header__topbar}>
        <div className={styles.topbar__wrapp}>
          <a href="tel:+48883341617" className={styles.header__phone}>
            <svg
              viewBox="0 0 19 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 1.5H7L9 6.5L6.5 8C7.57096 10.1715 9.32847 11.929 11.5 13L13 10.5L18 12.5V16.5C18 17.0304 17.7893 17.5391 17.4142 17.9142C17.0391 18.2893 16.5304 18.5 16 18.5C12.0993 18.263 8.42015 16.6065 5.65683 13.8432C2.8935 11.0798 1.23705 7.40074 1 3.5C1 2.96957 1.21071 2.46086 1.58579 2.08579C1.96086 1.71071 2.46957 1.5 3 1.5Z"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
            <div className={styles.header__number}>
              {t("header.book_table")}
            </div>
          </a>
        </div>
      </div> */}

      {!isHomePage && !children && (
        <div
          className={`${styles.header__wrapp} ${
            contentDirection === "reverse" ? styles.header__wrappReverse : ""
          }`}
        >
          <div className={styles.header__img}>
            <img src={contentImage} alt="hero" />
          </div>

          <div className={styles.header__txt}>
            <h1 className={styles.header__title}>{t("header.title")}</h1>
            <p className={styles.header__description}>
              {t("header.description")}
            </p>
          </div>
        </div>
      )}

      {/* {isHomePage && !children && (
        <div className={styles.header__homeTitleContainer}>
          <div className={styles.header__homeTitle}>
            {t("home_menu.title")}
            <br></br>
            {t("home_menu.title2")}
          </div>
        </div>
      )} */}

      {/* {isHomePage && !children && (
        <div className={styles.header__homeTitleContainer}>
          <div className={styles.header__homeTitle}>
            <div className={styles.header__newYearCatchphrase}>
              {t("header.new_year_catchphrase")}
            </div>
            <Link
              to="/menu#new-year-sets"
              className={styles.header__newYearButton}
            >
              {t("header.check_new_year_sets")}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.16602 10.0003H15.8327M15.8327 10.0003L12.4993 13.3337M15.8327 10.0003L12.4993 6.66699"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      )} */}

      {(showScrollButton || (isHomePage && !children)) && (
        <>
          <div
            className={styles.home__scroll}
            onClick={() => {
              const el = document.querySelector(
                "[data-scroll-follow]"
              ) as HTMLElement;
              if (!el) return;

              scrollToElement(el, 900);
            }}
          >
            <div className={styles.home__scrollTxt}>{t("header.scroll")}</div>
            <div className={styles.home__scrollArrow}>
              <svg
                className={styles.home__scrollSvg}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 9L12 15L18 9"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
          </div>
        </>
      )}

      {children ? children : null}
    </header>
  );
};
